import { CSSProperties, FC } from 'react';
import { Modal, ModalProps } from 'components/Modal';

import styles from './ModalKitModal.module.scss';
import clsx from 'clsx';
import { useWindowSize } from 'hooks/breakpoints';

export type ModalKitModalProps = ModalProps & {
  desktopHeight?: number;
  desktopWidth?: number;
};

export const ModalKitModal: FC<ModalKitModalProps> = ({
  className,
  onClose,
  children,
  desktopHeight,
  desktopWidth,
  ...props
}) => {
  const { isDesktop } = useWindowSize();

  const desktopSizing: CSSProperties =
    isDesktop && desktopHeight && desktopWidth
      ? {
          width: '100%',
          height: desktopHeight,
          maxWidth: desktopWidth,
        }
      : {};

  return (
    <Modal
      style={{
        content: desktopSizing,
      }}
      className={clsx(styles.modal, className)}
      onClose={onClose}
      {...props}
    >
      {children}
    </Modal>
  );
};
